module.exports = __webpack_public_path__ + "static/img/weixuanzhongwode.png@2x.863e9c63.png";